import React from "react";
import { Styles } from "./styles";
import i18next, { t } from "i18next";
import { useSelector } from "react-redux";
import Logo from "../../../../assets/images/small_logo.webp";

const Lesson = ({ lessonNum, videoUrl, selectedVideo, setVideoUrl }) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const isAr = i18next.language === "ar";

  const setVideo = () => {
    setVideoUrl("");
    setVideoUrl(videoUrl);
  };

  return (
    <Styles isAr={isAr}>
      <div className="lesson" onClick={setVideo}>
        <div className={selectedVideo === videoUrl ? "lesson-img selected" : "lesson-img"}>
          <img src={Logo} alt="lesson  image" />
          <div
            className={
              selectedVideo === videoUrl ? "watched selected" : "watched"
            }
          >
            {Resource?.section ? Resource?.section : t("section")} {lessonNum}
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Lesson;
